import { API_ENDPOINTS } from '@/constants/api-endpoints';
import {
  IMessageTemplate,
  ICreateTemplatePayload,
  IUpdateTemplatePayload,
  IListTemplatesParams,
  IRenderTemplatePayload,
  IRenderTemplateResponse,
} from '@/types/templates';
import { apiInstance } from '@/utils/axios';

export const createTemplate = async (
  payload: ICreateTemplatePayload,
): Promise<IMessageTemplate> => {
  const response = await apiInstance.post(API_ENDPOINTS.createTemplate, payload);
  return response.data;
};

export const updateTemplate = async (
  templateId: string,
  payload: IUpdateTemplatePayload,
): Promise<IMessageTemplate> => {
  const response = await apiInstance.put(API_ENDPOINTS.updateTemplate(templateId), payload);
  return response.data;
};

export const deleteTemplate = async (templateId: string): Promise<void> => {
  await apiInstance.delete(API_ENDPOINTS.deleteTemplate(templateId));
};

export const getTemplate = async (templateId: string): Promise<IMessageTemplate> => {
  const response = await apiInstance.get(API_ENDPOINTS.getTemplate(templateId));
  return response.data;
};

export const listTemplates = async (params?: IListTemplatesParams): Promise<IMessageTemplate[]> => {
  const response = await apiInstance.get(API_ENDPOINTS.listTemplates, { params });
  return response.data;
};

export const renderTemplate = async (
  templateId: string,
  payload: IRenderTemplatePayload,
): Promise<IRenderTemplateResponse> => {
  const response = await apiInstance.post(API_ENDPOINTS.renderTemplate(templateId), payload);
  return response.data;
};
